import { Link } from '@ecomm/framework/Link'
import { useIsAIChatEnabled } from '../../../hooks/useIsAIChatEnabled'
import { accountMenuItems } from '../data'

const menuItemClass =
  'h-16 lg:w-60 lg:border-solid lg:hover:bg-neutral-100 lg:text-neutral-black hover:underline relative z-10 flex w-full items-center justify-end border-0 border-primary-100 border-b-neutral-300 text-lg first:border-b-2  no-underline text-white'

type AccountMenuItemsProps = {
  readonly showDropdown: boolean
  readonly handleOnClick: (label: string) => void
}

export function AccountMenuItems({
  showDropdown,
  handleOnClick
}: AccountMenuItemsProps) {
  const isAIChatEnabled = useIsAIChatEnabled()
  const accountItems = accountMenuItems(isAIChatEnabled)

  return accountItems.map((item, i) =>
    /(http|https):\/\/.*/.test(item.url) ? (
      <a
        className={menuItemClass}
        href={item.url}
        key={i}
        onClick={() => {
          handleOnClick(item.text)
        }}
        rel="noreferrer"
        tabIndex={showDropdown ? 0 : -1}
        target="_blank"
      >
        <div className="ml-4 mr-3">{item.icon}</div>
        <div className="mb-1 flex-grow">{item.text}</div>
      </a>
    ) : (
      <Link
        className={menuItemClass}
        key={i}
        onClick={() => {
          handleOnClick(item.text)
        }}
        tabIndex={showDropdown ? 0 : -1}
        to={item.url}
      >
        <div className="ml-4 mr-3">{item.icon}</div>
        <div className="mb-1 flex-grow">{item.text}</div>
      </Link>
    )
  )
}
